import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { log } from 'console';

interface LoaderState {
  isLoading: boolean;
}

const initialState: LoaderState = {
  isLoading: false,
};

const loadingSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoading: (state) => {
      state.isLoading = true;
    },
    hideLoading: (state) => {
      state.isLoading = false;
    },
  },
});

export const { showLoading, hideLoading} = loadingSlice.actions;

export default loadingSlice.reducer;
